import React from 'react';

export const ShareOutLineIcon: React.FC = () => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="16" cy="4.18191" r="2.27273" stroke="#2B3F6C" strokeWidth="1.36364" />
    <circle cx="5.09109" cy="10.5454" r="2.27273" stroke="#2B3F6C" strokeWidth="1.36364" />
    <path
      d="M13.7273 5.54541L7.36366 9.18177"
      stroke="#2B3F6C"
      strokeWidth="1.36364"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.90922 12.3636L13.7274 16.4545"
      stroke="#2B3F6C"
      strokeWidth="1.36364"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="16" cy="17.8181" r="2.27273" stroke="#2B3F6C" strokeWidth="1.36364" />
  </svg>
);
